import { Calendar, MessageCircle, Sparkles, BarChart3 } from 'lucide-react';
import { LandingTemplate, type LandingData } from '../components/LandingTemplate';
import { LANDING_GUIDES } from '../lib/landingGuides';

const data: LandingData = {
  seo: {
    title: 'Cómo programar tweets en X (Twitter) · Zettapost',
    description:
      'Cómo programar tweets en X: desde x.com y con Zettapost, junto a tus otras redes y en varias cuentas a la vez. Prueba 3 días gratis.',
    canonical: 'https://zettapost.com/programar-x',
  },
  hero: {
    eyebrow: 'Programar X (Twitter)',
    headlinePre: 'Programa tus tweets en X',
    headlineAccent: 'sin abrir la app.',
    subhead:
      'Lanza tus tweets a la hora exacta, en todas tus cuentas, sin estar pendiente del feed. Más impacto, menos tiempo perdido.',
    bullets: [
      'Tweets con imagen o vídeo',
      'IA que escribe el copy',
      'Multi-cuenta',
      '3 días gratis',
    ],
  },
  why: {
    eyebrow: '¿Por qué Zettapost para X?',
    title: 'La forma más limpia de programar X.',
    subtitle:
      'Pensado para community managers, marcas y profesionales que viven en X pero no quieren vivir en X 24/7.',
    items: [
      {
        Icon: Calendar,
        title: 'Programa cuando rinde',
        description:
          'Lanza tus tweets en las horas de máximo alcance de tu nicho. Zettapost publica automáticamente, también de noche y los fines de semana.',
      },
      {
        Icon: MessageCircle,
        title: 'Un texto para cada red',
        description:
          'Escribe una vez y adapta el texto para X: más corto y directo que en LinkedIn o Facebook. Si tienes X Premium, puedes programar posts de hasta 2.200 caracteres.',
      },
      {
        Icon: Sparkles,
        title: 'IA que escribe por ti',
        description:
          'Sube una idea o una imagen y la IA te genera el tweet con el gancho adecuado, dentro de los 280 caracteres, listo para publicar.',
      },
      {
        Icon: BarChart3,
        title: 'Métricas que importan',
        description:
          'Impresiones, likes, retweets y respuestas de cada tweet en un panel único. Sabe qué horarios y qué temas te están funcionando.',
      },
    ],
  },
  guide: LANDING_GUIDES.x,
  faqs: [
    {
      q: '¿Puedo programar hilos en X?',
      a: 'Todavía no. Zettapost programa posts sueltos, con imágenes o vídeo; un hilo, de momento, hay que publicarlo desde X. Si tu cuenta tiene X Premium, puedes programar posts largos de hasta 2.200 caracteres.',
    },
    {
      q: '¿Usáis la API oficial de X?',
      a: 'Sí, conectamos a través de la API oficial de X. Eso garantiza que tus publicaciones sean tratadas igual que si las publicaras desde la app, sin penalizaciones en el alcance.',
    },
    {
      q: '¿Puedo conectar varias cuentas de X?',
      a: 'Sí. Los planes con varias cuentas permiten gestionar X de varios clientes o marcas desde el mismo panel, con sus colores y tono de voz propios.',
    },
    {
      q: '¿Soporta imágenes y vídeo?',
      a: 'Sí. Puedes adjuntar hasta 4 imágenes o un vídeo por tweet, igual que en la app oficial.',
    },
    {
      q: '¿Qué pasa con los retweets?',
      a: 'La programación cubre tweets nuevos. Las respuestas y los retweets simples sin comentario se hacen desde X — son más reactivos por naturaleza y conviene hacerlos en el momento.',
    },
    {
      q: '¿Tengo límite de tweets al mes?',
      a: 'No. Ningún plan limita el número de tweets — programa todos los que necesites. Los planes se diferencian por número de cuentas conectadas y funciones avanzadas.',
    },
  ],
  finalCta: {
    title: 'Programa tu próximo tweet',
    titleAccent: 'sin abrir la app.',
    description: 'Crea tu cuenta y conecta X gratis durante 3 días.',
  },
  related: [
    { to: '/programar-linkedin', label: 'Programar LinkedIn' },
    { to: '/programar-threads', label: 'Programar Threads' },
    { to: '/precios', label: 'Ver precios' },
    { to: '/blog', label: 'Blog' },
  ],
};

export function ProgramarX() {
  return <LandingTemplate data={data} />;
}
